// @flow strict

import * as React from 'react';
import { iframeResizer } from 'iframe-resizer';
import cx from 'classnames';
import queryString from 'query-string';
import styles from './styles.scss';

type IframeData = {
  iframe: React.Element<'iframe'>,
  height: number,
  width: Number,
  type: string,
};

type PropTypes = {|
  src: string,
  className?: string,
  appliedMinHeight?: boolean,
  height?: string,
  title?: string,
  onResize?: (data?: IframeData) => void,
|};

export default (props: PropTypes) => {
  const ref = React.useRef();
  const [src, setSrc] = React.useState();
  React.useLayoutEffect(() => {
    const height = props.height || '500';
    iframeResizer(
      {
        checkOrigin: [
          'https://info.ansarada.com',
          'https://my.webinarninja.com',
          'https://zoom.us',
          'https://go.ansarada.com',
        ],
        minHeight: props.appliedMinHeight ? height : 0,
        resizedCallback: props.onResize ? props.onResize : () => {},
      },
      ref.current,
    );
  });

  React.useEffect(() => {
    let params;
    let pageTitle;
    const pattern = new RegExp(/\?.+=.*/g);
    const hasQuery = pattern.test(props.src);
    if (typeof window !== 'undefined' && window.location.search) {
      params = queryString.parse(window.location.search);
    }

    if (typeof document !== 'undefined' && document.title) {
      pageTitle = document.title;
    }
    let query = queryString.stringify({
      page_title: pageTitle,
      ...params,
    });
    if (query) {
      query = `${hasQuery ? '&' : '?'}${query}`;
    }
    setSrc(`${props.src}${query}`);
  }, [props.src]);

  return (
    <>
      <iframe
        className={cx('lazyload', styles.iframe, props.className)}
        ref={ref}
        src={src}
        title={props.title || 'Form'}
      />
      <noscript>
        <iframe className={cx(styles.iframe, props.className)} ref={ref} src={src} title="Form" />
      </noscript>
    </>
  );
};
